<template>

  <div class="help-panels">

    <v-expansion-panels tile>

      <v-expansion-panel>
        <v-expansion-panel-header>
         {{ $t('helpContents.ordersForMe.whatIsOrdersForMe.title') }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-html="$t('helpContents.ordersForMe.whatIsOrdersForMe.contents')"></div>
        </v-expansion-panel-content>
      </v-expansion-panel>

    </v-expansion-panels>


  </div>


</template>

<script>

export default {
  name: 'OrdersForMeHelp',
  props: {
  },
  data () {
    return {
    }
  },
}
</script>


<style scoped>

</style>
